import { computed as o, inject as h, ref as S, useSlots as C, Text as I } from "vue";
import { buttonGroupContextKey as k } from "./index608.js";
import { useDeprecated as F } from "./index664.js";
import { useGlobalConfig as z } from "./index620.js";
import { useFormItem as D } from "./index585.js";
import { useFormSize as G, useFormDisabled as T } from "./index586.js";
const q = (n, c) => {
  F(
    {
      from: "type.text",
      replacement: "link",
      version: "3.0.0",
      scope: "props",
      ref: "https://element-plus.org/en-US/component/button.html#button-attributes"
    },
    o(() => n.type === "text")
  );
  const a = h(k, void 0), u = z("button"), { form: i } = D(), d = G(o(() => a?.size)), r = T(), v = S(), s = C(), f = o(
    () => {
      var t;
      return n.type || a?.type || ((t = u.value) == null ? void 0 : t.type) || "";
    }
  ), m = o(
    () => {
      var t, e, l;
      return (l = (e = n.autoInsertSpace) != null ? e : (t = u.value) == null ? void 0 : t.autoInsertSpace) != null ? l : !1;
    }
  ), _ = o(
    () => {
      var t, e, l;
      return (l = (e = n.plain) != null ? e : (t = u.value) == null ? void 0 : t.plain) != null ? l : !1;
    }
  ), b = o(
    () => {
      var t, e, l;
      return (l = (e = n.round) != null ? e : (t = u.value) == null ? void 0 : t.round) != null ? l : !1;
    }
  ), p = o(() => {
    var t, e, l;
    return (l = (e = n.text) != null ? e : (t = u.value) == null ? void 0 : t.text) != null ? l : !1;
  }), g = o(() => n.tag === "button" ? {
    ariaDisabled: r.value || n.loading,
    disabled: r.value || n.loading,
    autofocus: n.autofocus,
    type: n.nativeType
  } : {}), y = o(() => {
    var t;
    const e = (t = s.default) == null ? void 0 : t.call(s);
    if (m.value && e?.length === 1) {
      const l = e[0];
      if (l?.type === I) {
        const x = l.children;
        return /^\p{Unified_Ideograph}{2}$/u.test(x.trim());
      }
    }
    return !1;
  });
  return {
    _disabled: r,
    _size: d,
    _type: f,
    _ref: v,
    _props: g,
    _plain: _,
    _round: b,
    _text: p,
    shouldAddSpace: y,
    handleClick: (t) => {
      if (r.value || n.loading) {
        t.stopPropagation();
        return;
      }
      n.nativeType === "reset" && i?.resetFields(), c("click", t);
    }
  };
};
export {
  q as useButton
};
